import { render, staticRenderFns } from "./KuaishouBall.vue?vue&type=template&id=4f34a29a&scoped=true&"
import script from "./KuaishouBall.vue?vue&type=script&lang=js&"
export * from "./KuaishouBall.vue?vue&type=script&lang=js&"
import style0 from "./KuaishouBall.vue?vue&type=style&index=0&id=4f34a29a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f34a29a",
  null
  
)

export default component.exports